import ApplicationModel from '../models/application'
import RootController from 'structure-root-controller'

/**
 * ApplicationsController Class
 *
 * @public
 * @class ApplicationsController
 */
export default class Controller extends RootController {

  /**
   * ApplicationsController constructor
   *
   * @public
   * @constructor
   * @param {Object} options - Options
   */
  constructor(options = {}) {
    super(Object.assign({}, {
      name: 'applications'
    }, options))
  }

  /**
   * Get application by id
   *
   * @public
   * @param {Object} req - Express req
   * @param {Object} res - Express res
   */
  byHostname(req, res) {

    const organizationId = req.headers.organizationid
    const application = new ApplicationModel({
      logger: this.logger,
      organizationId
    })

    return application.getByHostname(req.params.hostname, organizationId)

  }

  /**
   * Create new application
   *
   * @public
   * @param {Object} req - Express req
   * @param {Object} res - Express res
   */
  async create(req, res) {

    const organizationId = req.headers.organizationid
    const application = new ApplicationModel({
      logger: this.logger,
      organizationId
    })

    let pkg = req.body

    if(req.hostname) {
      pkg.hostname = req.hostname
    }

    pkg.organizationId = organizationId

    return application.create(pkg)

  }

  deleteById(req, res) {

    const organizationId = req.headers.organizationid
    const application = new ApplicationModel({
      logger: this.logger,
      organizationId
    })

    return application.deleteById(req.params.id)

  }

  /**
   * Get all applications
   *
   * @public
   * @param {Object} req - Express req
   * @param {Object} res - Express res
   */
  getAll(req, res) {

    const organizationId = req.headers.organizationid
    const application = new ApplicationModel({
      logger: this.logger,
      organizationId
    })

    return application.getAll()

  }

  /**
   * Get application by id
   *
   * @public
   * @param {Object} req - Express req
   * @param {Object} res - Express res
   */
  getById(req, res) {

    const organizationId = req.headers.organizationid
    const application = new ApplicationModel({
      logger: this.logger,
      organizationId
    })

    return application.getById(req.params.id)

  }

  /**
   * Get organization
   *
   * @public
   * @param {Object} req - Express req
   * @param {Object} res - Express res
   */
  getOrganization(req, res) {

    const organizationId = req.headers.organizationid
    const application = new ApplicationModel({
      logger: this.logger,
      organizationId
    })

    return application.getOrganization(req.params.id)

  }

  /**
   * Get applications of user
   *
   * @public
   * @param {Object} req - Express req
   * @param {Object} res - Express res
   */
  ofUser(req, res) {

    const organizationId = req.headers.organizationid
    const application = new ApplicationModel({
      logger: this.logger,
      organizationId
    })

    return application.ofUser(req.params.id)

  }

  /**
   * Update a application
   *
   * @public
   * @param {Object} req - Express req
   * @param {Object} res - Express res
   */
  updateById(req, res) {

    const organizationId = req.headers.organizationid
    const application = new ApplicationModel({
      logger: this.logger,
      organizationId
    })

    return application.updateById(req.params.id, req.body)

  }

}
